import api from "../../../../../service/api";

const rootUrl = 'tms/';

export const getStudents = (id) => api.get(`tms/batch-students/get-batch-students/${id}`);

export const getBatchData = (id) => api.get(`tms/batches/getbatch/${id}`);

export const getPdfTemplateListData = (id) => api.get(`tms/bca-forms/get-template-list`);
